export enum PaymentCondition {
    FLEXIBLE = 1,
    FIXED = 2
}